module.exports = __webpack_public_path__ + "img/ZJ5229.e31a855a.png";